import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=5c120c48"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"
import style0 from "./Field.vue?vue&type=style&index=0&id=5c120c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports